export function findBundledProductsMatchingVariant(bundledProducts, selectedColor, selectedFit) {
  if (bundledProducts.length === 0) {
    return []
  }

  const filteredColors = bundledProducts.filter(product => product.color.name !== selectedColor)
  return selectedFit
    ? filteredColors.filter(product => product.product_fits.find(fit => fit.id !== selectedFit.id))
    : filteredColors
}

export function findLineItemsMatchingBundle(lineItems, bundle) {
  return lineItems.reduce((bundledItems, lineItem) => {
    if (lineItem.bundle && lineItem.bundle.id === bundle.id) {
      const lineItems = Array(lineItem.quantity).fill(lineItem)

      return [...bundledItems, ...lineItems]
    } else {
      return bundledItems
    }
  }, [])
}

export function findBundlesInLineItems(lineItems) {
  return lineItems.reduce((bundles, lineItem) => {
    const existingBundle = bundles.find(
      bundle => lineItem.bundle && bundle.id === lineItem.bundle.id,
    )

    if (lineItem.bundle && !existingBundle) {
      return [...bundles, lineItem.bundle]
    } else {
      return bundles
    }
  }, [])
}

export function getTitleForBundledItems(lineItems) {
  const firstItem = lineItems[0]

  if (firstItem.sku.startsWith('F')) {
    return 'Women’s Bundle'
  } else if (firstItem.sku.startsWith('M')) {
    return 'Men’s Bundle'
  } else {
    return 'Bundle'
  }
}

export function getBundlePrice(bundle, pricePerUnit = null) {
  const convertedPricePerUnit = pricePerUnit || bundle.converted_discounted_price_per_unit

  return convertedPricePerUnit * bundle.threshold_count
}

export function getBundleFromProduct(product) {
  if (!product || !product.bundle_info) {
    return {}
  }

  return product.bundle_info
}
